import { Dialog, DialogActions, DialogContent } from '@mui/material';
import React,{useEffect, useState} from 'react'
import SelectTermsTemplate from '../../../finance/termsTemplate/section/SelectTermsTemplate';
import moment from 'moment';

function InlineEdit({caption, field,value,callBack, isPrinting,inputType}) {

    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const [inputText,setInputText] = useState("")


    useEffect(()=>{
        if(value!==null){
            setInputText(value);
        }
    },[value])

    const update = () =>{
        let payload ={};
        payload[field] = inputText;
        callBack(payload);
        setDialogStatus(false);
    }

    return (
        <>
            
                {(value == null || value == "") && !isPrinting ?
                    <span type="button" className='text-muted fw-bold' onClick={()=>setDialogStatus(true)} > 
                        {caption}
                    </span>
                    :
                    <span type="button" className='fw-bold' onClick={()=>setDialogStatus(true)}>
                        {inputType==="date" ? moment(value).format("DD-MMMM-Y") : value}
                    </span>
                }
            
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogContent>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="form-floating my-3">
                                {inputType  && inputType!=="textarea" ?
                                    <input type={inputType} className='form-control'  value={inputText} onChange={(e)=>setInputText(e.target.value)} />
                                    :
                                    <textarea className="form-control" value={inputText} onChange={(e)=>setInputText(e.target.value)} rows={10} style={{height:400}}></textarea>
                                }
                                <label for="floatingTextarea2">{caption}</label>
                            </div>
                        </div>
                        
                    </div>
                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline-primary' onClick={()=>{setDialogStatus(false)}}>Cancel </button>
                    <button className='btn btn-success' onClick={update} >Update</button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default InlineEdit